import { MyPageView } from "../components/account/MyPageView";
import { SiteLayout } from "../components/layout/SiteLayout";
import { getAccountCopy } from "../data/accountCopy";
import { createLocalizedMeta } from "../utils/routeMeta";

export const meta = createLocalizedMeta({
	title: locale => getAccountCopy(locale).myPage.metaTitle,
	description: locale => getAccountCopy(locale).myPage.metaDescription,
	path: "/mypage",
});

export default function MyPage() {
	return (
		<div className="account-surface account-page">
			<SiteLayout>
				<MyPageView />
			</SiteLayout>
		</div>
	);
}
